import React from 'react'
import { Header } from 'semantic-ui-react'

export const NotFound = () => (
  <Header as="h1" textAlign="center">
    Requested page has not been found
  </Header>
)
